import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'
import PoiService from '../../services/PoiService'
import ProjectService from '../../services/ProjectsService'
import MasterplanService from '../../services/MasterplanService'
import Buildingervice from '../../services/BuildingService'
import ApartmentService from '../../services/ApartmentService'
import MenuItemsService from '../../services/MenuItemsService'
import MenuItemsHelper from '../../helpers/MenuItemsHelper'
import Enums from '../../helpers/Enums'
import ProjectsService from '../../services/ProjectsService'

export const namespaced = true

const initialState = {
  poiContext: 'app',
  pois: [],
  selectedPoi: null,
  selectedPoiParent: null,
  poiTypes: [],
  selectedType: {
    type: {},
    availableParents: []
  },
  availablePoisForSelectedMenuItemLinking: [],
  hasTitleMediaItem: false,
  hasDescriptionMediaItem: false,
  hasTitleImageMediaItem: false
}

export const state = {
  poiContext: 'app',
  pois: [],
  selectedPoi: null,
  selectedPoiParent: null,
  poiTypes: [],
  selectedType: {
    type: {},
    availableParents: []
  },
  availablePoisForSelectedMenuItemLinking: [],
  hasTitleMediaItem: false,
  hasDescriptionMediaItem: false,
  hasTitleImageMediaItem: false
}

export const mutations = {
  SET_POI_CONTEXT(state, rec) {
    if (
      rec === 'app' ||
      rec === 'masterplan' ||
      rec === 'building' ||
      rec === 'apartment' ||
      rec === 'menu_item'
    )
      state.poiContext = rec
  },
  SET_POIS(state, recs) {
    state.pois = recs
  },
  SET_SELECTED_POI(state, rec) {
    state.selectedPoi = rec
  },
  // SET_SELECTED_POI_GALLERIES(state, rec) {
  // 	state.selectedPoiGalleries = rec;
  // },
  SET_POI_TYPES(state, recs) {
    state.poiTypes = recs
  },
  SET_SELECTED_POI_PARENT(state, rec) {
    state.selectedPoiParent = rec
  },
  SET_SELECTED_TYPE(state, rec) {
    state.selectedType = rec
  },
  SET_AVAILABLE_POIS_FOR_LINKING(state, recs) {
    state.availablePoisForSelectedMenuItemLinking = recs
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  },
  SET_HAS_TITLE_MEDIA_ITEM(state, value) {
    state.hasTitleMediaItem = value
  },
  SET_HAS_DESCRIPTION_MEDIA_ITEM(state, value) {
    state.hasDescriptionMediaItem = value
  },
  SET_HAS_TITLE_IMAGE_MEDIA_ITEM(state, value) {
    state.hasTitleImageMediaItem = value
  }
}

export const actions = {
  setPoiContext(context, value) {
    context.commit('SET_POI_CONTEXT', value)
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },
  fetchPois: function(context, value) {
    let res
    switch (state.poiContext) {
      case 'app':
        {
          res = PoiService.getPoisByClientAppId(
            context.rootGetters['ClientAppStore/getSelectedClientAppId']
          )
        }
        break
      case 'masterplan':
        {
          res = MasterplanService.getPoisForMasterplan(
            context.rootGetters['MasterplanStore/getSelectedMasterplanId']
          )
        }
        break
      case 'building':
        {
          res = Buildingervice.getPoisForBuilding(
            context.rootGetters['BuildingStore/getSelectedBuildingId']
          )
        }
        break
      case 'apartment':
        {
          res = ApartmentService.getPoisForApartment(
            context.rootGetters['ApartmentStore/getSelectedApartmentId']
          )
        }
        break
      case 'menu_item':
        {
          res = MenuItemsService.getPoisForMenuItem(
            context.rootGetters['MenuItemsStore/getSelectedMenuItemId']
          )
        }
        break
    }
    return res.then(
      r => {
        context.commit('SET_POIS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_POIS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setSelectedPoi: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    console.log(value, 'ssp')
    let oldPoiId = null
    if (context.state.selectedPoi) {
      oldPoiId = context.state.selectedPoi.id
    }
    let poi = await PoiService.getPoiById(value).catch(e => {
      context.commit('SET_SELECTED_POI', null)
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(e, context, router)
    })
    let poiParent = await PoiService.getPoisParent(value).catch(e => {
      context.commit('SET_SELECTED_POI_PARENT', null)
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(e, context, router)
    })

    context.commit('SET_SELECTED_POI', poi.data)
    context.commit('SET_SELECTED_POI_PARENT', poiParent.data)

    await context.dispatch('checkPoiHasRequiredMediaItems')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },
  getPoisParent(context, value) {
    return PoiService.getPoisParent(value)
  },
  fetchPoiTypes(context, value) {
    if (value) {
      return PoiService.getPoiTypesForParentType(value).then(
        r => {
          context.commit('SET_POI_TYPES', r.data)
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        },
        e => {
          context.commit('SET_POI_TYPES', null)
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          AxiosErrorHandler.handler(e, context, router)
        }
      )
    } else {
      return PoiService.getAllPoiTypes().then(
        r => {
          context.commit('SET_POI_TYPES', r.data)
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        },
        e => {
          context.commit('SET_POI_TYPES', null)
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          AxiosErrorHandler.handler(e, context, router)
        }
      )
    }
  },
  createPoi: function(context, value) {
    if (state.poiContext === 'menu_item') {
      context.dispatch('createPoiForMenuItem', value)
    } else {
      return PoiService.createPoi(value).then(context.dispatch('fetchPois'))
    }
  },

  updatePoi: function(context, value) {
    if (state.poiContext === 'menu_item') {
      context.dispatch('updatePoiForMenuItem', value)
    } else {
      return PoiService.updatePoi(value).then(
        res => {
          context.dispatch('fetchPois')
          context.commit('SET_SELECTED_POI', res.data)
          context.dispatch(
            'BreadcrumbsStore/update',
            {
              text: 'P.O.I ',
              name: res.data.name
            },
            { root: true }
          )
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        },
        e => {
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          AxiosErrorHandler.handler(e, context, router)
        }
      )
    }
  },

  deletePoi: async function(context, value) {
    if (state.poiContext === 'menu_item') {
      context.dispatch('deletePoiForMenuItem', value)
    } else {
      try {
        return await PoiService.deletePoi(value)
      } catch (error) {
        AxiosErrorHandler.handler(error, context, router)
        throw error
      }
    }
  },
  setSelectedType: function(context, value) {
    // value -> poiType
    if (value) {
      switch (value.parentType) {
        case 'masterplan':
          {
            ProjectService.getProjectMasterplans(
              context.rootGetters[
                'ClientAppStore/getSelectedClientAppProjectId'
              ]
            ).then(
              r => {
                context.commit('SET_SELECTED_TYPE', {
                  type: value,
                  availableParents: r.data
                })
                context.commit('SET_LOADING_STATUS', 'idle', { root: true })
              },
              e => {
                context.commit('SET_SELECTED_TYPE', null)
                context.commit('SET_LOADING_STATUS', 'idle', { root: true })
                AxiosErrorHandler.handler(e, context, router)
              }
            )
          }
          break
        case 'building':
          {
            ProjectService.getProjectBuildings(
              context.rootGetters[
                'ClientAppStore/getSelectedClientAppProjectId'
              ]
            ).then(
              r => {
                context.commit('SET_SELECTED_TYPE', {
                  type: value,
                  availableParents: r.data
                })
                context.commit('SET_LOADING_STATUS', 'idle', { root: true })
              },
              e => {
                context.commit('SET_SELECTED_TYPE', null)
                context.commit('SET_LOADING_STATUS', 'idle', { root: true })
                AxiosErrorHandler.handler(e, context, router)
              }
            )
          }
          break
        case 'apartment':
          {
            ProjectService.getProjectApartments(
              context.rootGetters[
                'ClientAppStore/getSelectedClientAppProjectId'
              ]
            ).then(
              r => {
                context.commit('SET_SELECTED_TYPE', {
                  type: value,
                  availableParents: r.data
                })
                context.commit('SET_LOADING_STATUS', 'idle', { root: true })
              },
              e => {
                context.commit('SET_SELECTED_TYPE', null)
                context.commit('SET_LOADING_STATUS', 'idle', { root: true })
                AxiosErrorHandler.handler(e, context, router)
              }
            )
          }
          break
      }
    }
  },

  // MENU ITEMS POIS

  fetchPoisForMenuItem: function(context, value) {
    MenuItemsService.getPoisForMenuItem(
      context.rootGetters['MenuItemsStore/getSelectedMenuItemId']
    ).then(
      r => {
        context.commit('SET_POIS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_POIS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  createPoiForMenuItem: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return MenuItemsService.createPoiForMenuItem(
      context.rootGetters['MenuItemsStore/getSelectedMenuItemId'],
      value
    ).then(context.dispatch('fetchPoisForMenuItem'))
  },
  updatePoiForMenuItem: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return MenuItemsService.updatePoiForMenuItem(
      context.rootGetters['MenuItemsStore/getSelectedMenuItemId'],
      value
    ).then(context.dispatch('fetchPoisForMenuItem'))
  },
  deletePoiForMenuItem: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return MenuItemsService.deletePoiForMenuItem(
      context.rootGetters['MenuItemsStore/getSelectedMenuItemId'],
      value
    ).then(context.dispatch('fetchPoisForMenuItem'))
  },
  getAvailablePoisForMenuItemLinking: function(context, value) {
    if (state.poiContext == 'menu_item') {
      console.log('Menu item context')
      return PoiService.getPoisByClientAppId(
        context.rootGetters['ClientAppStore/getSelectedClientAppId']
      ).then(
        r => {
          console.log('Menu item context inside', r.data)

          context.commit(
            'SET_AVAILABLE_POIS_FOR_LINKING',
            MenuItemsHelper.filterLinkedItems(state.pois, r.data)
          )
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        },
        e => {
          context.commit('SET_AVAILABLE_POIS_FOR_LINKING', null)
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          AxiosErrorHandler.handler(e, context, router)
        }
      )
    } else {
      context.commit('SET_AVAILABLE_POIS_FOR_LINKING', null)
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    }
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },
  setTitleImage: async function(context, value) {
    let result
    try {
      result = await PoiService.setTitleImage(value.poiId, value.mediaId)
    } catch (e) {
      AxiosErrorHandler.handler(e, context, router)
    }
    return result
  },
  checkPoiHasRequiredMediaItems: async function({
    commit,
    rootGetters,
    state
  }) {
    if (!state.selectedPoi) {
      console.warn('selectedPoi not set', state.selectedPoi)
      return
    }

    let media = await PoiService.getMediaForPoi(state.selectedPoi.id, {
      pageNumber: 0,
      pageSize: 0,
      mediaTypeId: 0,
      langId: 0
    })
    commit(
      'SET_HAS_TITLE_MEDIA_ITEM',
      !!media.data.find(
        m =>
          m.langId === rootGetters['ProjectStore/getDefaultLangId'] &&
          [Enums.MediaType.poi_title].includes(m.mediaTypeId)
      )
    )
    commit(
      'SET_HAS_DESCRIPTION_MEDIA_ITEM',
      !!media.data.find(
        m =>
          m.langId === rootGetters['ProjectStore/getDefaultLangId'] &&
          [Enums.MediaType.description].includes(m.mediaTypeId)
      )
    )
    commit(
      'SET_HAS_TITLE_IMAGE_MEDIA_ITEM',
      !!media.data.find(m => {
        console.log('SET_HAS_TITLE_IMAGE_MEDIA_ITEM', m)
        return (
          m['PoiContent'] &&
          m['PoiContent']['properties'] &&
          Object.prototype.hasOwnProperty.call(
            m['PoiContent']['properties'],
            'order'
          ) &&
          m['PoiContent']['properties'].order === 1 &&
          [Enums.MediaType.poi_image].includes(m.mediaTypeId)
        )
      })
    )
  },
  getTitleImage: async function(context, value) {
    let response = await PoiService.getPoiTitleImage(
      context.state.selectedPoi.id,
      {
        langId: value
      }
    )
    return response.data
  }
}

export const getters = {
  getSelectedPoiId: state => {
    return state.selectedPoi ? state.selectedPoi.id : 0
  },
  showTitleMediaItemGhost: state => {
    return !state.hasTitleMediaItem
  },
  showDescriptionMediaItemGhost: state => {
    return !state.hasDescriptionMediaItem
  },
  showTitleImageMediaItemGhost: state => {
    return !state.hasTitleImageMediaItem
  }
}
